import { ReactNode } from 'react';

import { createFetchContext } from '../../../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../../../components/info/DisplayError';
import Loading from '../../../../../../components/info/Loading';
import { getAcademicOfferSummaryData } from '../../../api';
import { useAcademicOfferWizard } from '../../../context/AcademicOfferWizardContext';
import { CeAcademicOfferSummaryResponse } from '../../../types';

const {
  FetchProvider: AcademicOfferSummaryProvider,
  useFetch: useAcademicOfferSummary,
} = createFetchContext<number | string, CeAcademicOfferSummaryResponse>();

interface Props {
  children: ReactNode;
}

export function AcademicOfferSummaryLoader({ children }: Readonly<Props>) {
  const { ceAcademicOfferId } = useAcademicOfferWizard();

  if (!ceAcademicOfferId) {
    return <DisplayError textBody="CONNECTION" />;
  }

  return (
    <AcademicOfferSummaryProvider
      request={getAcademicOfferSummaryData}
      fetchImmediately
      defaultQuery={ceAcademicOfferId}
    >
      <AcademicOfferSummaryContent>{children}</AcademicOfferSummaryContent>
    </AcademicOfferSummaryProvider>
  );
}

function AcademicOfferSummaryContent({ children }: Readonly<Props>) {
  const { loading, error, data } = useAcademicOfferSummary();

  if (loading) {
    return <Loading />;
  }

  if (error || !data) {
    return <DisplayError textBody={error?.code ?? 'CONNECTION'} />;
  }

  return <>{children}</>;
}

export { useAcademicOfferSummary };
